<template>
    <v-tooltip right :disabled="!description" :color="color">
        <template v-slot:activator="{on}">
            <div style="width: 100%; height: 100%;" v-on="on">
                <div
                        ref="text"
                        class="tooltip-text"
                        :style="{justifyContent: align === 'end' ? 'flex-end' : (align === 'center' ? 'center' : 'flex-start')}"
                >
                    <div
                            class="ellipsis"
                            :style="{maxWidth: width + 'px'}"
                            :class="{'word_break': overflow}"
                    >
                        {{ text }}
                    </div>
                    <img v-if="src" :src="src" style="width: 20px; height: 20px; margin-left: 3px;">
                </div>
            </div>
        </template>
        <div style="max-width: 600px;">
            {{ description }}
        </div>
    </v-tooltip>
</template>

<script>
    export default {
        name: "VueDataTableTooltipText",
        props: {
            overflow: {
                type: Boolean,
                default: false,
            },
            align: {
                type: String,
                default: "start",
            },
            width: {
                type: Number,
                default: undefined,
            },
            text: null,
            description: {
                type: String,
                default: undefined,
            },
            color: {
                type: String,
                default: undefined,
            },
            src: {
                type: String,
                default: undefined,
            },
        },
        data() {
            return {
                // isOverflowed: false,
            };
        },
        watch: {
            text(newVal, oldVal) {
                // this.calculateOverflow();
            },
        },
        mounted() {
            // this.calculateOverflow();
        },
        methods: {
            /**
             * client height 보다 scroll height 가 크다면 컨텐츠가 보이는 영역을 넘어섰음을 의미한다.
             * 그럴 땐 overflow 를 true 로 만들어 tooltip 을 제공할 수 있도록 한다.
             */
            calculateOverflow() {
                this.$nextTick(() => {
                    this.isOverflowed = (this.$refs.text.scrollHeight > this.$refs.text.clientHeight)
                        || (this.$refs.text.scrollWidth > this.$refs.text.clientWidth);
                });
            }
        },
    }
</script>

<style scoped>
    .tooltip-text {
        display: flex;
        align-items: center;
        justify-content: stretch;
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow-y: hidden;
        max-height: 75px;
        cursor: default;
        width: 100%;
        padding: 8px 8px;
    }

    /*text 말줄임표 스타일*/
    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
    }

    /*text 줄바꿈 스타일*/
    .word_break {
        word-break: break-all;
        white-space: normal;
    }
</style>